import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'PARENT_BOOKING_SETTINGS';

export const {
    action: fetchData,
    success: fetchDataSuccess,
    failed: fetchDataFailed,
} = createAction(
    `${domain}/FETCH_DATA`,
    (institutionId: string) => ({institutionId}),
    () => ({}),
);
